import { component_avatar_Zeno_str, component_avatar_female01_str, component_avatar_female02_str, component_avatar_female03_str, component_avatar_female04_str, component_avatar_female05_str, component_avatar_female06_str, component_avatar_female07_str, component_avatar_female08_str, component_avatar_male01_str, component_avatar_male02_str, component_avatar_male03_str, component_avatar_male04_str, component_avatar_male05_str, component_avatar_male06_str, component_avatar_male07_str, component_avatar_male08_str, component_avatar_avatarHelmet_dark_str, component_avatar_avatarHelmet_light_str } from '@zenlayer/zen-design-icons';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { error as errorConsoleLog } from '../_util/devConsoleLog';
import { pickDomAttrs } from '../_util/utils';
import { ThemeAutoSwitchHOC } from '../hooks/useThemeSwitch';
import SvgIcon from '../svg-icon';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AvatarIcons = {
  zeno: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_Zeno_str
  }),
  female01: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_female01_str
  }),
  female02: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_female02_str
  }),
  female03: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_female03_str
  }),
  female04: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_female04_str
  }),
  female05: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_female05_str
  }),
  female06: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_female06_str
  }),
  female07: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_female07_str
  }),
  female08: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_female08_str
  }),
  male01: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_male01_str
  }),
  male02: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_male02_str
  }),
  male03: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_male03_str
  }),
  male04: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_male04_str
  }),
  male05: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_male05_str
  }),
  male06: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_male06_str
  }),
  male07: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_male07_str
  }),
  male08: /*#__PURE__*/_jsx(SvgIcon, {
    svgStr: component_avatar_male08_str
  })
};
const Avatar = props => {
  const {
    helmet,
    type = 'circle',
    size = 'm',
    icon,
    img,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-avatar");
  const InnerIcon = useMemo(() => {
    return !!icon ? /*#__PURE__*/React.cloneElement(icon, {
      className: classNames(icon.props.className, 'inner')
    }) : null;
  }, [icon]);
  if (type !== 'circle' && helmet) {
    //type==="circle"时候才能戴头盔
    errorConsoleLog(true, 'Avatar', '"helmet" must be used when type==="circle".');
    return null;
  }
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsxs("span", {
    ...attrs.data,
    className: classNames(className, baseClassName, {
      ["".concat(baseClassName, "-").concat(size)]: !!size,
      ["".concat(baseClassName, "-").concat(type)]: !!type
    }),
    style: style,
    children: [InnerIcon, img, helmet && /*#__PURE__*/_jsx(ThemeAutoSwitchHOC, {
      className: "helmet",
      dark: /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: component_avatar_avatarHelmet_dark_str
      }),
      light: /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: component_avatar_avatarHelmet_light_str
      })
    })]
  });
};
export default Avatar;